import {Injectable} from '@angular/core';
import {EnvName, getEnvName} from '../../../environments/env-name';
import {environment} from '../../../environments/environment';
import {AuthService, CurrentUser} from './auth.service';
import {catchError, filter, skip, take} from 'rxjs/operators';
import {of} from 'rxjs';
import {DemoService} from 'app/core/services/demo.service';
import {injectScript} from 'app/core/helpers/dom';

/* eslint-disable */
// insert intercom code
/* !!! WARNING !!!
by default this script is supposed to be inserted in <head> when page is loading.
this is modified version of The Intercom loader, to load it dynamically when page is loaded
to be able not to load it in dev\stage environment
 */
const intercomScript = `(function(){var w=window;var ic=w.Intercom;if(typeof ic==='function'){ic('reattach_activator');ic('update',intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/${JSON.stringify(
    environment.intercomApp)}';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(d.readyState==='complete'||d.readyStage==='interactive'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;
/* eslint-enable */

const prepareUserFields = (user: CurrentUser) =>
    user.permissions
        ? {
              email: user.email,
              name: user.name,
              created_at: user.createdAt,
              can_view_publishers_dashboard: user.permissions.canViewPublishersDashboard,
              can_view_old_dashboard: user.permissions.canViewOldDashboard,
              user_hash: user.intercomSign,
          }
        : {};

declare const window;

@Injectable({
    providedIn: 'root',
})
export class IntercomService {
    public disabled = true;
    private hideDefaultLauncher = false;

    constructor(
        private auth: AuthService,
        private demo: DemoService
    ) {}

    /* istanbul ignore next */

    get intercomClient(): Function {
        return window['Intercom'];
    }

    init() {
        if (this.demo.isDemoHost) {
            this.disabled = false;
            return;
        }
        if (getEnvName() !== EnvName.Prod) {
            console.log('The Intercom should be disabled');
            return;
        }
        console.log('The Intercom should be enabled');

        if (!environment.intercomApp) {
            console.log('The Intercom app key is missed!');
            return;
        }
        this.initIntercom();
    }

    /* istanbul ignore next */
    initIntercom() {
        injectScript(intercomScript, document.head);

        this.auth.currentUser$
            .pipe(
                catchError(err => of({} as CurrentUser)),
                filter(Boolean),
                take(1)
            )
            .subscribe((user: CurrentUser) =>
                this.intercomClient('boot', {
                    app_id: environment.intercomApp,
                    ...prepareUserFields(user),
                })
            );
        this.disabled = false;
        this.auth.currentUser$.pipe(filter(Boolean), skip(1)).subscribe(
            (user: CurrentUser) =>
                this.intercomClient('update', {
                    ...prepareUserFields(user),
                    hide_default_launcher: this.hideDefaultLauncher,
                }),
            () => null
        );
    }

    update() {
        if (!this.intercomClient) {
            return;
        }
        this.intercomClient('update', {
            hide_default_launcher: this.hideDefaultLauncher,
        });
    }

    hide() {
        this.hideDefaultLauncher = true;
        this.update();
    }

    show() {
        this.hideDefaultLauncher = false;
        this.update();
    }
}
